export const IMAGE = 'image'
export const AUDIO = 'audio'
export const VIDEO = 'video'
export const LINK = 'link'
